module.exports = __webpack_public_path__ + "fonts/NespressoLucas-XtraBdItalic.woff?v=4b8c4b9c7df4ebd547d6d9376b3dafd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-XtraBdItalic.woff
// module id = 687
// module chunks = 0